import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';




import { useAuth } from '../core/AuthProvider';
import { useEvent } from "../context/eventContext";

import { add_category_template, get_category_template_list } from '../FirebaseUtils/dbSettings';
import { add_Category, clear_all_category, edit_Category } from '../FirebaseUtils/dbCategory';
import TemplateMenu from '../components/menu/TemplateMenu';

const cleanCategory = (c) => {
    let r  ={
        category_name: c.category_name,
        category_description: c.category_description,
        category_section: c.category_section || '',
        cow_age_months_start: c.cow_age_months_start,
        cow_birth_start: c.cow_birth_start,
        cow_age_months_end: c.cow_age_months_end,
        category_number: c.category_number,
        cow_birth_end: c.cow_birth_end,
        check_lastbirthdate: c.check_lastbirthdate || false,
        cow_lastbirthage_start: c.cow_lastbirthage_start || new Date(),
        cow_lastbirthage_end: c.cow_lastbirthage_end || new Date(),
    }
    if (c.id !== undefined){
        r.id = c.id
    }
    if (c.order!== undefined){
        r.order = c.order
    }
    return r

}

export const CategoryTemplateMenu = ({ category_list, reloadFn, childRefDelete }) => {
    const { user } = useAuth()

    const { selEvent } = useEvent()


    const load_listFn = async () => {
        const data = await get_category_template_list()
        return data
    }



    const saveTemplate = async () => {
        console.log(category_list.map(c => cleanCategory(c)))
        const res = await add_category_template(user.uid, { name: 'template categoria', category_list: category_list.map(c => cleanCategory(c)) })
    }


    const loadListFromTemplate = async (t) => {
        console.log("DO LOAD")
        if (selEvent.id) {
            const res = await clear_all_category(selEvent.id)
            console.log("DELETE", res)
            for (const c of t.category_list) {
                console.log(c)
                if (c.id){
                    edit_Category(user.uid, selEvent.id, c.id, cleanCategory(c))
                }else{
                    add_Category(user.uid, selEvent.id, cleanCategory(c))
                }
            }
            reloadFn()
        }
        //childRefDelete.current.confirmDelete('Carica Template categorie', `Caricando il template: <b>${tmpl.name}</b> sovrascriverai tutte le categorie attualmente presenti in questo evento`, cb)
    }

    return (
        <TemplateMenu
            label="template categorie"
            saveAs={category_list.length > 0 && saveTemplate}
            loadTemplate={loadListFromTemplate}
            load_listFn={load_listFn}
            element_name="categorie"
        />


    )
}
/* 

export const CategoryTemplateManagementDialog = ({ reloadFn, category_list }) => {
    const { user } = useAuth()

    const childRefDelete = useRef()
    const [open, setOpen] = useState(false);
    const [element_list, setElementList] = useState([])
    const { selEvent } = useEvent()





    const handleOpen = () => {
        initData()
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };










    const initData = async () => {
        const data = await get_category_template_list()
        setElementList(data)
    }



    const handleTemplate = async () => {
        const res = await add_category_template(user.uid, { name: 'template categoria', category_list: category_list.map(c => cleanCategory(c)) })
        setOpen(false)
    }


    const loadTemplate = (tmpl) => {
        const cb = async () => {
            if (selEvent.id) {
                const res = await clear_all_category(selEvent.id)
                console.log("DELETE", res)
                for (const c of tmpl.category_list) {
                    console.log(c)
                    add_Category(user.uid, selEvent.id, cleanCategory(c))
                }
                reloadFn()
                setOpen(false)
            }
        }
        childRefDelete.current.confirmDelete('Carica Template categorie', `Caricando il template: <b>${tmpl.name}</b> sovrascriverai tutte le categorie attualmente presenti in questo evento`, cb)
    }


    return (
        <div>

            <Button variant="outlined" size="small" onClick={handleOpen} startIcon={<ColorLens />}>template categorie</Button>
            <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="xl">
                <DeleteconfirmationSection ref={childRefDelete} />
                <DialogTitle>
                    Template categorie
                </DialogTitle>
                <DialogContent>
                    <Grid container flexDirection={"row"} justifyContent={"stretch"} spacing={2}>
                        <Grid container flexDirection={"column"} size="grow">
                            <Grid container sx={globalstyles.sectionHeader} >
                                <Grid size="grow">

                                </Grid>
                                <Grid size="grow">
                                    &nbsp;
                                </Grid>
                            </Grid>
                            <Button disabled={category_list.length === 0} onClick={handleTemplate} variant="contained" size="small" startIcon={<Save />}>salva lista attuale come nuovo template</Button>
                        </Grid>
                        <Grid container flexDirection={"column"} size="grow">
                            <Grid container sx={globalstyles.sectionHeader} size="grow">
                                Lista template
                            </Grid>
                            <Grid container sx={globalstyles.listHeader}>
                                <Grid size="grow">
                                    Nome
                                </Grid>
                                <Grid size={1}>
                                    Numero categorie
                                </Grid>
                                <Grid size={3}>
                                </Grid>
                            </Grid>
                            {console.log("element", element_list)}
                            {element_list?.map((c, k) => (
                                <Grid container key={k} sx={{ ...globalstyles.list_row }}>
                                    <Grid size="grow">
                                        {c.name}<br />
                                    </Grid>
                                    <Grid size={1}>
                                        {c.category_list?.length}
                                    </Grid>
                                    <Grid size={3}>
                                        <Button disabled={selEvent.lock_catalog} size="small" variant="outlined" color="secondary" onClick={() => loadTemplate(c)}>Carica template</Button>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>

                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

 */